// Light enforcement: Round quantity to nearest multiple of 5 (>=5) on change/blur
document.addEventListener('DOMContentLoaded', () => {
  // Target quantity inputs on product page and cart
  document.querySelectorAll('input[name="quantity"], input[name^="updates"]').forEach(input => {
    input.addEventListener('change', () => {
      let val = parseInt(input.value, 10);
      if (isNaN(val) || val < 5) {
        input.value = 5;
      } else {
        // Round to nearest multiple of 5
        input.value = Math.round(val / 5) * 5;
      }
    });
    // Trigger on blur (tab out)
    input.addEventListener('blur', () => {
      input.dispatchEvent(new Event('change'));
    });
  });
});